import React from "react";

// Mismo formateador en toda la plataforma — Intl con currency COP, sin
// decimales (el peso colombiano no usa centavos en la práctica).
const COP = new Intl.NumberFormat("es-CO", {
  style: "currency",
  currency: "COP",
  minimumFractionDigits: 0,
});

/**
 * PriceWithDiscount — precio original tachado + % de descuento + precio
 * final, en un solo componente reutilizado en toda la plataforma (Paquetes,
 * Registrar pago, Mi saldo, detalle de pago, cartera) para que el mismo
 * paquete se vea igual en cualquier pantalla donde aparezca su precio.
 *
 * Sin descuento (o listPrice === finalPrice): solo el precio, sin tachado ni
 * badge — no hay nada que "explicar".
 */
function PriceWithDiscount({ listPrice, discountPct, finalPrice, size = "normal", className }) {
  const discount = Number(discountPct ?? 0);
  const hasDiscount =
    discount > 0 &&
    listPrice != null &&
    finalPrice != null &&
    Number(listPrice) !== Number(finalPrice);

  if (!hasDiscount) {
    const value = finalPrice ?? listPrice;
    return (
      <span className={`fw-bold ${className ?? ""}`}>
        {value != null ? COP.format(value) : "—"}
      </span>
    );
  }

  const originalSize = size === "sm" ? ".75rem" : ".85em";

  return (
    <span className={className}>
      <span
        className="text-muted text-decoration-line-through me-2"
        style={{ fontSize: originalSize }}
      >
        {COP.format(listPrice)}
      </span>
      <span className="badge bg-danger-subtle text-danger border border-danger-subtle me-2">
        -{discount}%
      </span>
      <span className="fw-bold">{COP.format(finalPrice)}</span>
    </span>
  );
}

export { PriceWithDiscount, COP };
